import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import { URLBunge } from "../../Componentes/Config";
import MenuPrinc from "../../Componentes/MenuPrinc";
import ListaLojas1500 from "../../Componentes/ListaLojas";
import ListaLojasBonificacao from "../../Componentes/ListaLojaBonificacao";
import Carregando from "../../Componentes/Carregando";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  CampoFormBusca,
  BtIcoBuscar,
  BtVoltar,
  BtVoltar2,
  BtVoltarContainer,
  BtLimparFiltro,
  CardContainer
} from "./styles";

import IcoBusca from "../../Images/ico_search_branco.png";
import ImgBtSetaVoltar from "../../Images/BtSeta.png";

function Recompra1500Bonificacao(props) {
  const ItensPagina = 10;
  const history = useHistory();
  const { register, handleSubmit, errors, control, setValue, watch } =
    useForm();
  const [TipoPesquisa, setTipoPesquisa] = useState(6);
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [page1, setPage1] = useState(0);
  const [page2, setPage2] = useState(ItensPagina);
  const [RazaoSap, setRazaoSap] = useState("");
  const [Loading, setLoading] = useState(false);
  const [SemInformacoes, setSemInformacoes] = useState(true);
  const [ListaLojas, setListaLojas] = useState([]);
  const [ListaLojasTotal, setListaLojasTotal] = useState([]);
  const [ListarPerguntasPesquisaCompleta, setListarPerguntasPesquisaCompleta] =
    useState([]);

  const c_token = localStorage.getItem("c_token");
  const c_cpf = localStorage.getItem("c_cpf");

  const ListarRazaoSapNovo = async (tipo) => {
    setRazaoSap("");
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + c_token);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(
      `${URLBunge}/api/Pesquisa/ListarRazaoSapNovo/` + c_cpf + `/` + tipo,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso) {
          // console.log('ListarRazaoSapNovo', result);
          setTimeout(() => {
            setSemInformacoes(false);
            setListaLojas(result.lista);
            setListaLojasTotal(result.lista);
          }, 400);
        }

        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((error) => setLoading(false));
  };

  const Paginacao = (page) => {
    setLoading(true);
    if (page == "prev") {
      if (page1 > 1) {
        setPage1(page1 - ItensPagina);
        setPage2(page2 - ItensPagina);
      }
    }
    if (page == "next") {
      if (page2 < ListaLojas.length) {
        setPage1(page1 + ItensPagina);
        setPage2(page2 + ItensPagina);
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  function MudaPesquisa(Tipo) {
    setTipoSelecionado(Tipo);
    setListaLojas([]);
    setListaLojasTotal([]);
    setSemInformacoes(true);
    if (Tipo === 0) {
      ListarRazaoSapNovo(6);
    } else {
      ListarRazaoSapNovo(7);
    }
  }

  const FiltrarClientes = async () => {
    setLoading(true);

    var matches = ListaLojasTotal.filter(function (s) {
      let ProcuraNome = s.nome.toUpperCase().match(RazaoSap.toUpperCase());
      let ProcuraCNPJ = s.cnpj.toUpperCase().match(RazaoSap.toUpperCase());
      let ProcuraSAP = s.sap.toUpperCase().match(RazaoSap.toUpperCase());
      if (ProcuraNome) {
        var RetornaBusca = ProcuraNome;
      }
      if (ProcuraCNPJ) {
        var RetornaBusca = ProcuraCNPJ;
      }
      if (ProcuraSAP) {
        var RetornaBusca = ProcuraSAP;
      }
      return RetornaBusca;
    });
    setListaLojas(matches);
    setPage1(0);
    setPage2(ItensPagina);

    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  const LimparFiltro = async () => {
    setLoading(true);
    setRazaoSap("");
    setListaLojas(ListaLojasTotal);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  };

  useEffect(() => {
    ListarRazaoSapNovo(TipoPesquisa);
    // document.body.style.scroll = "auto";
  }, []);

  return (
    <>
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Bonificação de Introdução e 1.500</TitNoticias>
            <Clear />
            <Clear />
            <BtVoltar
              onClick={() => history.push({ pathname: "/home", state: {} })}
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>
            <BtVoltarContainer>
              <BtVoltar2
                onClick={() => {
                  MudaPesquisa(0);
                }}
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: `${
                    TipoSelecionado === 0 ? "#3fb6fa" : "#043c54"
                  }`,
                }}
              >
                <div>RECOMPRA 1.500 LOJAS</div>
              </BtVoltar2>
              <Clear />
              <BtVoltar2
                onClick={() => {
                  MudaPesquisa(1);
                }}
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: `${
                    TipoSelecionado === 1 ? "#3fb6fa" : "#043c54"
                  }`,
                }}
              >
                <div>BONIFICAÇÃO DE INTRODUÇÃO</div>
              </BtVoltar2>
            </BtVoltarContainer>
            <Clear />
            <CampoFormBusca>
              <input
                ref={register}
                id="c_razaosap"
                name="c_razaosap"
                value={RazaoSap}
                type="text"
                onChange={(event) => setRazaoSap(event.target.value)}
                placeholder={"Razão social ou SAP"}
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
              />
              <BtIcoBuscar onClick={() => FiltrarClientes()}>
                <img src={IcoBusca} />
              </BtIcoBuscar>
            </CampoFormBusca>
            {RazaoSap.length > 0 && (
              <BtLimparFiltro onClick={() => LimparFiltro()}>
                LIMPAR FILTRO
              </BtLimparFiltro>
            )}
            <Clear />
            <Clear />
            <CardContainer
              id="ScrollRolling"
              // style={{ overflowY: "scroll", height: "62vh" }}
            >
              {TipoSelecionado === 0 &&
                ListaLojas.map((item, index) => {
                  return <ListaLojas1500 item={item} key={index} />;
                })}
              {TipoSelecionado === 1 &&
                ListaLojas.map((item, index) => {
                  return <ListaLojasBonificacao item={item} key={index} />;
                })}
            </CardContainer>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default Recompra1500Bonificacao;
